module.exports = __webpack_public_path__ + "static/media/NCP_contentsPage_ko.3448f072.png";